import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ImportDataComponent} from './import-data.component';


export const importDataRoutes: Routes = [
  {
    path: 'import-data',
    component: ImportDataComponent,
    data: {
      'expectedRoles': ['Admin', 'IT', 'UIH']
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(importDataRoutes)],
  exports: [RouterModule]
})
export class ImportDataRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data-routing.module.ts